var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3188,
    height: 3822,
    viewBox: "0 0 3188 3822",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.404 437.11C231.26 256.146 142.009 153.012 58.8876 39.5231C47.0253 23.3269 58.6986 1 78.7742 1H3102.22C3115.88 1 3127.01 11.9544 3127.22 25.6063L3186.6 3795.61C3186.82 3809.57 3175.56 3821 3161.6 3821H48.5251C38.2632 3821 28.9166 3814.74 25.7846 3804.96C-18.2661 3667.52 74.3374 3547.99 150.404 3417.93C229.414 3282.84 136.59 3097.09 62.6913 2973.01C-11.2073 2848.93 -25.0214 2631.61 62.6913 2538.37C150.404 2445.12 277.254 2222.96 119.958 2067.75C-37.3377 1912.54 22.1039 1625.77 119.958 1480.4C217.812 1335.03 206.942 1271.15 62.6913 1009.78C-81.5593 748.407 60.5207 638.279 150.404 437.11Z",
    fill: "#7A53FF",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignCurve);
export default __webpack_public_path__ + "static/media/designCurve.45b5d1204b15aa473fa822fa5f1e21d0.svg";
export { ForwardRef as ReactComponent };